import { render, staticRenderFns } from "./UpgradePlanTagButton.vue?vue&type=template&id=14c9f881&scoped=true"
import script from "./UpgradePlanTagButton.vue?vue&type=script&lang=ts"
export * from "./UpgradePlanTagButton.vue?vue&type=script&lang=ts"
import style0 from "./UpgradePlanTagButton.vue?vue&type=style&index=0&id=14c9f881&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c9f881",
  null
  
)

export default component.exports